// Generated by Melange

import * as Buhta_cabinet__Contract from "../../components/organisms/Documents/Contracts/Contract.js";
import * as Buhta_cabinet__Contracts from "../../components/organisms/Documents/Contracts/Contracts.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as JsxRuntime from "react/jsx-runtime";

function ContractsPage(Props) {
  let org = Props.org;
  const currentUrlStr = Buhta_cabinet__Route.toString(Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined)));
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
        title: "Договоры",
        rightChildren: JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                      route: {
                        TAG: /* Org */6,
                        _0: org.id,
                        _1: {
                          TAG: /* Documents */1,
                          _0: {
                            TAG: /* Contracts */0,
                            _0: /* Create */1
                          }
                        }
                      },
                      className: "border border-gray-pale rounded px-3 py-2",
                      children: JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                            children: "Загрузить договор"
                          }),
                      urlParams: {
                        hd: [
                          "return_to",
                          currentUrlStr
                        ],
                        tl: /* [] */0
                      }
                    }),
                JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                      route: {
                        TAG: /* Org */6,
                        _0: org.id,
                        _1: {
                          TAG: /* Documents */1,
                          _0: {
                            TAG: /* Contracts */0,
                            _0: /* Create */1
                          }
                        }
                      },
                      className: "bg-links rounded px-3 py-2 ml-4",
                      children: JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                            className: "text-white",
                            children: "Новый договор"
                          })
                    })
              ],
              className: "flex"
            })
      });
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  let viewContract;
  if (typeof currentRoute === "number" || !(currentRoute.TAG === /* Org */6 && currentRoute._0 === 1)) {
    viewContract = false;
  } else {
    const match = currentRoute._1;
    if (typeof match === "number" || match.TAG !== /* Documents */1) {
      viewContract = false;
    } else {
      const match$1 = match._0;
      if (typeof match$1 === "number" || match$1.TAG !== /* Contracts */0) {
        viewContract = false;
      } else {
        const match$2 = match$1._0;
        viewContract = typeof match$2 === "number" || match$2.TAG !== /* View */0 ? false : match$2._0 === 1;
      }
    }
  }
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
              header: header,
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_cabinet__Contracts.make, {
                                  viewContract: viewContract,
                                  org: org
                                }),
                            viewContract ? JsxRuntime.jsx(Buhta_cabinet__Contract.make, {
                                    org: org
                                  }) : null
                          ],
                          className: "min-h-full flex"
                        }),
                    className: "flex flex-col w-full"
                  })
            });
}

const make = ContractsPage;

export {
  make ,
}
/* Buhta_cabinet__Contract Not a pure module */
